define(["jquery", "jquery-validation"], function( $ ) {
	//全角ひらがな･カタカナのみ
  $.validator.addMethod("kana", function(value, element) {
    return this.optional(element) || /^([ァ-ヶーぁ-ん]+)$/.test(value);
  }, "全角ひらがな･カタカナを入力してください");

  //全角ひらがなのみ
  $.validator.addMethod("hiragana", function(value, element) {
    return this.optional(element) || /^([ぁ-ん]+)$/.test(value);
  }, "全角ひらがなを入力してください");

  //全角カタカナのみ
  $.validator.addMethod("katakana", function(value, element) {
    return this.optional(element) || /^([ァ-ヶー]+)$/.test(value);
  }, "全角カタカナを入力してください");

  //半角カタカナのみ
  $.validator.addMethod("hankana", function(value, element) {
    return this.optional(element) || /^([ｧ-ﾝﾞﾟ]+)$/.test(value);
  }, "半角カタカナを入力してください");
  
  //半角アルファベット（大文字･小文字）のみ
  $.validator.addMethod("alphabet", function(value, element) {
    return this.optional(element) || /^([a-zA-z\s]+)$/.test(value);
  }, "半角英字を入力してください");
  
  //半角アルファベット（大文字･小文字）もしくは数字のみ
  $.validator.addMethod("alphanum", function(value, element) {
    return this.optional(element) || /^([a-zA-Z0-9]+)$/.test(value);
  }, "半角英数字を入力してください");
  
  //郵便番号（例:012-3456）
  $.validator.addMethod("postnum", function(value, element) {
    return this.optional(element) || /^\d{3}\-\d{4}$/.test(value);
  }, "郵便番号を入力してください（例:123-4567）");
  
  //携帯番号（例:010-2345-6789）
  $.validator.addMethod("mobilenum", function(value, element) {
    return this.optional(element) || /^0\d0-\d{4}-\d{4}$/.test(value);
  }, "携帯番号を入力してください（例:010-2345-6789）");
  
  //電話番号（例:012-345-6789）
  $.validator.addMethod("telnum", function(value, element) {
    return this.optional(element) || /^[0-9-]{12}$/.test(value);
  }, "電話番号を入力してください（例:0123-456-789）");
  
  //全角のみ
  $.validator.addMethod("zenkaku", function(value, element) {
    return this.optional(element) || /^[^ -~｡-ﾟ]*$/.test(value);
  }, "全角のみを入力してください");
    
  //ASCII文字のみ
  $.validator.addMethod("ascii", function(value, element) {
    return this.optional(element) || /^[\x20-\x7E]+$/.test(value);
  }, "ASCII文字を入力してください");
    
  $.validator.addMethod("emailfull", function(value, element) {
    return this.optional(element) || /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i.test(value);
  }, "Please enter valid email address.");
    
  $.validator.addMethod("passwordfull", function(value, element) {
    return this.optional(element) || /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(value);
  }, "半角の英字、数字、記号で入力してください");
    
  $.validator.addMethod("passwordRequired", function(value, element) {
    return this.optional(element) ||  /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])/ .test(value);
  }, "英字の大文字と小文字、数字をそれぞれ最低1文字ずつ使用してください");

  $("form").validate({
    ignore: [],
    errorElement: "p",
    errorClass: "error",
    onkeyup: function(element) {
      if($(element).attr('type') != 'email' && $(element).attr('name') != 'first_name_kana' && $(element).attr('name') != 'last_name_kana' && $(element).attr('name') != 'password' && $(element).attr('name') != 'password_confirmation'){
        $(element).valid();
      }
    },
    onfocusout: function(element) {
      $(element).valid();
    },
    rules: {
      budget: {
        required: true,
      },
      power_plant_scale: {
        required: true,
      },
      has_solar_power_property: {
        required: true,
      },
      purchase_desire_period: {
        required: true,
      },
      'purchase_method[]': {
        required: true,
      },
      'desired_area[]': {
        required: true,
      },
      employees:{
        required: true,
      },
      employment_status: {
        required: true,
      },
      has_owned_house:{
        required: true,
      },
      has_real_estate:{
        required: true,
      },
      conditions: {
        maxlength: 2000,
      },
      zip: {
        required: true,
        number: true,
      },
      city: {
        required: true,
        maxlength: 100,
      },
      building: {
        maxlength: 100,
      },
      has_house_owned: {
        required: true,
      },
      has_real_estate: {
        required: true,
      },
      has_solar_power_plant: {
        required: true,
      },
      company_name: {
        required: true,
        maxlength: 100,
      },
      company_tel: {
        number: true,
      },
      employee: {
        required: true,
      },
      company_type: {
        required: true,
      },
      annual_income: {
        required: true,
        number: true,
      },
      employment_status: {
        required: true,
      },
      position: {
        required: true,
        maxlength: 30,
      },
      work_years: {
        required: true,
        number: true,
      },
      number_of_lenders: {
        required: true,
      },
      total_debt: {
        required: true,
        number: true,
      },
      first_name: {
        required: true,
        maxlength: 30,
      },
      last_name: {
        required: true,
        maxlength: 30,
      },
      first_name_kana: {
        katakana: true,
        required: true,
        maxlength: 30,
      },
      last_name_kana: {
        katakana: true,
        required: true,
        maxlength: 30,
      },
      email: {
        required: true,
        emailfull: true,
        maxlength: 256,
      },
      tel: {
        number : true,
        minlength: 10,
        maxlength: 11,
      },
      company_tel: {
        required: true,
        minlength: 10,
        number : true,
        maxlength: 11,
      },
      password: {
        required: true,
        passwordfull: true,
        passwordRequired: true,
        minlength: 8,
        maxlength: 64,
      },
      password_confirmation: {
        required: true,
        equalTo : '[name="password"]',
      },
      newPropertyNum: {
        required: true,
      },
      oldPropertyNum: {
        required: true,
      },
      companyName: {
        required: true,
        maxlength: 100,
      },
    },
    messages: {
      budget: {
        required: "必須項目です。",
      },
      power_plant_scale: {
        required: "必須項目です。",
      },
      has_solar_power_property: {
        required: "必須項目です。",
      },
      purchase_desire_period: {
        required: "必須項目です。",
      },
      'purchase_method[]': {
        required: "必須項目です。",
      },
      'desired_area[]': {
        required: "必須項目です。",
      },
      employees:{
        required: "必須項目です。",
      },
      employment_status: {
        required: "必須項目です。",
      },
      has_owned_house:{
        required: "必須項目です。",
      },
      has_real_estate:{
        required: "必須項目です。",
      },
      conditions: {
        maxlength: "2,000文字以内で入力してください。",
      },
      zip: {
        required: '郵便番号は入力必須項目です。',
        number: 'ハイフン無しの半角数字のみ入力してください',
      },
      city: {
        required: '市区町村は入力必須項目です。',
        maxlength: "100文字以内で入力してください。",
      },
      building: {
        maxlength: "100文字以内で入力してください。",
      },
      has_house_owned: {
        required: "必須項目です。",
      },
      has_real_estate: {
        required: "必須項目です。",
      },
      has_solar_power_plant: {
        required: "必須項目です。",
      },
      company_name: {
        required: "必須項目です。",
        maxlength: "100文字以内で入力してください。",
      },
      company_tel: {
        number: '電話番号を入力してください（例:0123456789）',
      },
      employee: {
        required: "必須項目です。",
      },
      company_type: {
        required: "必須項目です。",
      },
      annual_income: {
        required: "必須項目です。",
        number: '半角英数字のみ入力してください。',
      },
      employment_status: {
        required: "必須項目です。",
      },
      position: {
        required: "必須項目です。",
        maxlength: "30文字以内で入力してください。",
      },
      work_years: {
        required: "必須項目です。",
        number: '半角英数字のみ入力してください。',
      },
      number_of_lenders: {
        required: "必須項目です。",
      },
      total_debt: {
        required: "必須項目です。",
        maxlength: "30文字以内で入力してください。",
        number: '半角英数字のみ入力してください。',
      },
      first_name: {
        required: "名は入力必須項目です。",
        maxlength: "名を30文字以内で入力してください。",
      },
      last_name: {
        required: "姓は入力必須項目です。",
        maxlength: "姓を30文字以内で入力してください。",
      },
      first_name_kana: {
        required: "メイは入力必須項目です。",
        maxlength: "メイを30文字以内で入力してください。",
        katakana: "メイは全角カタカナを入力してください",
      },
      last_name_kana: {
        required: "セイは入力必須項目です。",
        maxlength: "セイを30文字以内で入力してください。",
        katakana: "セイは全角カタカナを入力してください",
      },
      email: {
        required: 'メールアドレスは入力必須項目です。',
        emailfull: '正しいメールアドレスを254文字以内で入力してください。',
        email: '正しいメールアドレスを254文字以内で入力してください。',
        maxlength: "254文字以内で入力してください。",
      },
      tel: {
        required: '電話番号は必須項目です',
        number: 'ハイフンなしの半角数字10文字以上11文字以内で入力してください。',
        minlength: '10文字以上で入力してください。',
        maxlength: '11文字以内で入力してください。',
      },
      company_tel: {
        required: 'ハイフンなしの半角数字10文字以上11文字以内で入力してください。',
        number: 'ハイフンなしの半角数字10文字以上11文字以内で入力してください。',
        minlength: '10文字以上で入力してください。',
        maxlength: '11文字以内で入力してください。',
      },
      password: {
        required: 'パスワードは入力必須項目です。',
        minlength: '8文字以上64文字以内で入力してください。',
        maxlength: '8文字以上64文字以内で入力してください。',
      },
      password_confirmation: {
        required: 'パスワードは入力必須項目です。',
        minlength: '8文字以上64文字以内で入力してください。',
        maxlength: '8文字以上64文字以内で入力してください。',
        equalTo: 'パスワードと確認用パスワードが一致しません。',
      },
      newPropertyNum: {
        required: "必須項目です。",
      },
      oldPropertyNum: {
        required: "必須項目です。",
      },
      companyName: {
        required: "必須項目です。",
        maxlength: "100文字以内で入力してください。",
      },
    },
    errorPlacement: function (err, element) {
      element.parents('.account-form__input').append(err);
    },
    // errorElement: "span",
    errorClass: "is-error",
  });

  $('input[name="zip"]').on('keyup',function(){
    AjaxZip3.zip2addr('zip','','pref','city');
  });
});